import { render } from "./ModalSecurity.vue?vue&type=template&id=59ae507b"
import script from "./ModalSecurity.vue?vue&type=script&lang=js"
export * from "./ModalSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__